import Cookie from "js-cookie"
import PropTypes from "prop-types"
import qs from "query-string"
import React, { Component } from "react"
import { Helmet } from "react-helmet"
import MetaTags from "react-meta-tags"
import {
  getAddonByRace,
  getRaceBySlug,
  getRaceDetailByRace
} from "../api/async/index"
import { shouldShowConfirmPayment } from "../api/async/participants/index"
import { FeatureImage } from "../components/FeatureImage/index"
import { Loader } from "../components/Loader"
import { RaceDetail } from "../components/RaceDetail/index"
import RegisterRace from "../components/RegisterRace/index"
import MobileRegisterRace from "../components/RegisterRace/mobile"

class Race extends Component {
  state = {
    addons: [],
    racesDetail: [],
    isRegistered: false,
    special: false
  }

  componentDidMount = async () => {
    const slug = this.props.match.params.slug
    const raceRes = await getRaceBySlug(slug)
    this.setState({ race: raceRes.data })

    getAddonByRace(this.state.race.id).then(res =>
      this.setState({ addons: res.data })
    )
    getRaceDetailByRace(this.state.race.id).then(res =>
      this.setState({ racesDetail: res.data })
    )
    shouldShowConfirmPayment(this.state.race).then(result =>
      this.setState({ isRegistered: result })
    )
    // this.setSpecial()
  }

  setSpecial = () => {
    const search = this.props.location.search
    const params = qs.parse(search)
    const special = Cookie.get("run-24hrs-special") || params.special || false

    special && Cookie.set("run-24hrs-special", special, { expires: 3 })
    this.setState({ special })
  }

  render() {
    const id = this.props.match.params.id
    return (
      <React.Fragment>
        {this.state.racesDetail && this.state.race ? (
          <React.Fragment>
            <Helmet>
              <meta charSet="utf-8" />
              <title>{`Run24Hrs - ${this.state.race.title}`}</title>
            </Helmet>
            <MetaTags>
              <meta property="og:title" content={this.state.race.title} />
              <meta
                property="og:image"
                content={this.state.race.feature_image}
              />
            </MetaTags>
            <MobileRegisterRace
              race={this.state.race}
              {...this.state.race}
              isRegistered={this.state.isRegistered}
              special={this.state.special}
              racesDetail={this.state.racesDetail}
            />
            <div style={{ marginBottom: 10 }}>
              <FeatureImage imgSrc={this.state.race.feature_image} />
            </div>
            <div className="ui stackable grid">
              <div className="eleven wide column">
                <RaceDetail
                  race={this.state.race}
                  addons={this.state.addons}
                  racesDetail={this.state.racesDetail}
                />
              </div>
              <div className="five wide column">
                <RegisterRace
                  race={this.state.race}
                  {...this.state.race}
                  racesDetail={this.state.racesDetail}
                  special={this.state.special}
                  isRegistered={this.state.isRegistered}
                />
              </div>
            </div>
          </React.Fragment>
        ) : (
          <Loader />
        )}
      </React.Fragment>
    )
  }
}

Race.propTypes = {
  race: PropTypes.object,
  addons: PropTypes.arrayOf(PropTypes.object),
  racesDetail: PropTypes.arrayOf(PropTypes.object),
  showConfirmPayment: PropTypes.bool
}

export default Race



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Race.js